export default __webpack_public_path__ + "static/5-unique-ways-to-experience-french-delicacies-172812bcc4edc4558c1768e2b0872178.jpg";